<template>
  <div class="buy-rate">
    <label class="buy-rate__title">Include Buy Rate</label
    ><b-form-checkbox
      class="document-item__checkbox"
      v-model="includeBuyRate"
    />
  </div>
</template>

<script>
export default {
  name: "BuyRate",
  data() {
    return {
      includeBuyRate: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/components/Checkboxes.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;

.buy-rate {
    display: flex;
    align-items: center;
    gap: 20px;
    &__title {
      margin: 0px;
      color: $color-primary-company;
      font-weight: 600;
    }
}
</style>
